export default "__VITE_ASSET__ChYrvOP8__"